var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateRefreshCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 27c6.018 0 11-4.982 11-11 0-6.007-4.993-11-11.01-11C9.981 5 5 9.993 5 16c0 6.018 4.993 11 11 11zm-3.72-15.982c-.54.43-.659 1.013-.27 1.423.388.42.895.345 1.337.022.798-.615 1.596-.96 2.674-.96 2.211 0 4.045 1.488 4.54 3.462h-1.24c-.517 0-.625.496-.345.895l1.802 2.502c.302.41.82.442 1.143 0L23.7 15.86c.28-.4.183-.895-.345-.895h-1.11c-.55-3.095-3.053-5.22-6.224-5.22-1.39 0-2.782.485-3.742 1.273zm-2.2 2.566L8.3 16.097c-.28.399-.183.895.345.895H9.82c.55 3.095 3.051 5.22 6.222 5.22 1.391 0 2.782-.486 3.742-1.284.54-.42.669-1.003.27-1.413-.388-.42-.895-.355-1.337-.02-.799.614-1.596.948-2.675.948-2.21 0-4.044-1.488-4.54-3.45h1.175c.518 0 .626-.497.346-.896l-1.801-2.513c-.302-.41-.82-.431-1.143 0z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRefreshCircle);
export default __webpack_public_path__ + "static/media/Rotate_Refresh-Circle.63668887c016b324430c25c64c5f502f.svg";
export { ForwardRef as ReactComponent };